module.exports = __webpack_public_path__ + "static/media/photo16.7d61ca4f.jpg";